import { useQuery } from '@tanstack/react-query';
import { axiosInstance } from '@/modules/shared/lib/axios';
import { MINUTE_IN_MS } from '@/modules/shared/constants/time';
import { ConfigApiRolesResponse } from '../types/account';

type Props = {
  userUniqueId: string
}

/**
 * Fetches basic company settings.
 */
export function useQueryRoles({ userUniqueId }: Props) {
  return useQuery<ConfigApiRolesResponse>({
    queryKey: ['config.roles', userUniqueId],
    queryFn: async () => {
      const { data } = await axiosInstance.get(`/config-api/role`);
      return data;
    },
    staleTime: MINUTE_IN_MS * 5, // cache for 5 minutes
  });
}
